import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {PopoverDirective} from "ngx-bootstrap/popover";
import {NgClass} from "@angular/common";

@Component({
    selector: 'app-info-tooltip',
    templateUrl: './info-tooltip.component.html',
    imports: [
        TranslatePipe,
        PopoverDirective,
        NgClass
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoTooltipComponent {
    @Input() public text: string;
    @Input() public iconSize = 'md';
    @Input() public position = 'right';

    constructor() {}
}
